import { OnInit, Input, Component, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IbgeService } from '../../services/ibge.service';
import { Util } from '../../utils/util';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'uf',
    templateUrl: './uf.component.html',
    styleUrls: ['./uf.component.scss']
})
export class UfFormComponent implements OnInit {

    public states: any;

    @Input() pageMode: any;

    @Input() UFTitle = 'UF';

    @Input() obrigatorio = false;

    @Input() group: FormGroup;

    // Output para informar que a lista está carregada
    @Output() statesListLoadedEvent = new EventEmitter();

    MSG_CAMPO_OBRIGATORIO = Util.getMensagemCampoObrigatorio();

    constructor(
        private _ibgeService: IbgeService
    ) { }

    ngOnInit() {
        this.onChanges();
    }

    /**
     * Busca a lista de estados.
     */
    private getListEstados(): void {
        this._ibgeService.getListEstados()
            .subscribe(dados => {
                this.organizaEstados(dados);
                this.emitListLoadedEvent();
            });
    }

    /**
     * Busca a lista de estados do país enviado.
     * @param CodigoAlpha3 Código alpha do país.
     */
    private getListEstadosExterior(CodigoAlpha3: string): void {
        this._ibgeService.getListEstadosByPais(CodigoAlpha3)
            .subscribe(dados => {
                this.organizaEstados(dados);
                this.emitListLoadedEvent();
            });
    }

    /**
     * Emite informando que a lista está atualizada
     */
    private emitListLoadedEvent() {
        this.statesListLoadedEvent.emit();
    }

    /**
     * Organiza a lista de estados de acordo com o retorno da API.
     * @param dadosAPI Lista de estados vindos da API.
     */
    private organizaEstados(dadosAPI: any): void {
        if (dadosAPI) {
            this.states = Util.orderBy(dadosAPI, 'Sigla');
        } else {
            this.states = [];
        }
        this.group.get('Endereco.Municipio.UF.CodigoIBGE').setValue(-1);
    }

    /**
     * Método que controla as alterações feitas na lista de países.
     */
    private onChanges(): void {
        const paisComponent = this.group.get('Endereco.Municipio.UF.Pais.CodigoAlpha3');
        if (paisComponent) { // Caso componente seja utilizado junto com o componente de endereço
            paisComponent.valueChanges.subscribe(CodigoAlpha3 => {
                if (CodigoAlpha3 === -1) { // Caso não venha valores
                    this.states = [];
                    this.group.get('Endereco.Municipio.UF.CodigoIBGE').setValue(-1);
                } else if (CodigoAlpha3 === Util.getAlphaCodeBrazil()) { // Caso o país seja Brasil
                    this.getListEstados();
                } else { // Caso seja exterior
                    this.getListEstadosExterior(CodigoAlpha3);
                }
            });
        } else {
            this.getListEstados(); // Caso componente seja utilizado standalone
        }
    }

    // Método necessário para setar a sigla da UF quando mudar a opção selecionada
    onChangeUF(codigoIBGE) {
        if (!!this.group.get('Endereco.Municipio.UF.Sigla') && this.states) {
            const ufSelecionado = this.states.find(x => x.CodigoIBGE === codigoIBGE);

            if (ufSelecionado) {
                this.group.get('Endereco.Municipio.UF.Sigla').setValue(ufSelecionado.Sigla);
            }
        }
    }
}
